import { render, staticRenderFns } from "./BuroSilSihirbaziDialog.vue?vue&type=template&id=f900ad8c&scoped=true"
import script from "./BuroSilSihirbaziDialog.vue?vue&type=script&lang=ts"
export * from "./BuroSilSihirbaziDialog.vue?vue&type=script&lang=ts"
import style0 from "./BuroSilSihirbaziDialog.vue?vue&type=style&index=0&id=f900ad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f900ad8c",
  null
  
)

export default component.exports